import React, { Component } from 'react';
import './App.css';
import AceEditor from 'react-ace';

import 'brace/mode/json';
import 'brace/theme/github';
import 'brace/ext/language_tools'

import { Layout, Menu, Icon, Button, Modal, Form, Input, Popconfirm, Spin, notification, Empty } from 'antd';

const {
  Header, Content
} = Layout;

class App extends Component {

  constructor(props) {
    super(props);

    this.isAceEditorHaveValidContent = this.isAceEditorHaveValidContent.bind(this);
    this.onChange = this.onChange.bind(this);
    this.saveConfig = this.saveConfig.bind(this);
    this.loadConfig = this.loadConfig.bind(this);
    this.onCreateConfig = this.onCreateConfig.bind(this);
    this.onNewConfigFileNameChange = this.onNewConfigFileNameChange.bind(this);
    this.loadConfigs = this.loadConfigs.bind(this);
    this.removeConfig = this.removeConfig.bind(this);
    this.isConfigHaveUnsavedChanges = this.isConfigHaveUnsavedChanges.bind(this);

    this.state = {
      isCreateNewConfigFileVisible: false,
      isSaveButtonDisabled: true,
      value: '',
      selectedConfig: '',
      configNames: [],

      newConfigFileName: "",
      isValidNewConfigName: false,
      isLoading: false,
      isHaveUnsavedChanges: false
    };
  }

  getDefaultHeaders(){
    var headers = new Headers();
    headers.append('cache-control', 'no-cache');
    headers.append('pragma', 'no-cache');

    return headers;
  }

  onNewConfigFileNameChange(e) {
    var isValidConfigName = 
    /^[a-fA-F0-9]{12}$/i.test(e.target.value)  //1234567890ddee
    || /^([a-fA-F0-9]{2})+\:+([a-fA-F0-9]{2})+\:+([a-fA-F0-9]{2})+\:+([a-fA-F0-9]{2})+\:+([a-fA-F0-9]{2})+\:+([a-fA-F0-9]{2})$/i.test(e.target.value) //12:34:56:78:90:dd:ee
    || /^([a-fA-F0-9]{2})+\-+([a-fA-F0-9]{2})+\-+([a-fA-F0-9]{2})+\-+([a-fA-F0-9]{2})+\-+([a-fA-F0-9]{2})+\-+([a-fA-F0-9]{2})$/i.test(e.target.value);//12-34-56-78-90-dd-ee

    this.setState({
      newConfigFileName: e.target.value,
      isValidNewConfigName: isValidConfigName
    });
  }

  onCreateConfig(e) {
    var formattedNewConfigFile = this.state.newConfigFileName.replace(/[:-]/g, "").toLowerCase();

    this.setState({
      isLoading: true, 
    });
     
    var that = this;
    fetch(process.env.REACT_APP_API_ENDPOINT + "/configs/" + formattedNewConfigFile,
      {
        method: "put",
        headers: that.getDefaultHeaders()
      })
      .then(res => {
        if (!res.ok) {
          if(res.status === 401){
            window.location = process.env.REACT_APP_REDIRECT_URL;
          }

          throw new Error("Нет соединения с сервером! Попробуйте позже.");
        }

        return res.json();
      })
      .then(res => {
        if (res.success === true) {
          notification.success({
            message: "Контроллер успешно добавлен!"
          });

          var formattedNewConfigFileWithExtension = formattedNewConfigFile + ".json";

          var newConfigNames = that.state.configNames;
          newConfigNames.push(formattedNewConfigFileWithExtension);

          that.setState({
            isCreateNewConfigFileVisible: false,
            selectedConfig: formattedNewConfigFileWithExtension,
            newConfigFileName: "",
            isValidNewConfigName: false,
            configNames: newConfigNames
          });
        }
        else {
          notification.error({
            message: res.message
          });
        }
        that.setState({
          isLoading: false
        });
      })
      .catch(err => {
        notification.error({
          message: err.message
        });

        that.setState({
          isLoading: false
        });
      });

    e.preventDefault();
  }

  loadConfigs(callback) {
    this.setState({
      isLoading: true
    });

    var that = this;
    fetch(process.env.REACT_APP_API_ENDPOINT + "/configs/getAll", {
      method: "get",
      headers: that.getDefaultHeaders()
    })
      .then(res => {
        if (!res.ok) {

          if(res.status === 401){
            window.location = process.env.REACT_APP_REDIRECT_URL;
          }

          throw new Error("Необходимо авторизоваться в системе!")
        }
        return res.json();
      })
      .then(res => {
        that.setState({
          configNames: res,
          isSaveButtonDisabled: res.length === 0,
          selectedConfig: res[0]
        });

        //если есть хотя бы 1 файл, то загрузить его содержимое в редактор
        if (res.length !== 0) {
          var unsavedControllers = localStorage.getObj('unsavedControllers') || [];

          var unsavedControllersData = unsavedControllers.filter(function(item, index){
            return item.name === res[0];
          });
      
          if(unsavedControllersData.length !== 0){
      
            var unsavedControllerData = unsavedControllersData[0];
      
            this.setState({ 
              value: unsavedControllerData.content 
            });
          }
          else{
            that.loadConfig(res[0]);
          }
        }
        
        that.setState({
          isLoading: false
        });
        callback();
      })
      .catch(err => {
        notification.error({
          message: err.message
        });
        
        that.setState({
          isLoading: false
        });
        callback();
      });
  }

  removeConfig(configName, event) {
    event.stopPropagation();
    this.setState({
      isLoading: true
    });
    var that = this;

    fetch(process.env.REACT_APP_API_ENDPOINT + "/configs/" + configName, {
      method: "delete",
      headers: that.getDefaultHeaders()
    })
      .then(res => {
        if(!res.ok){

          if(res.status === 401){
            window.location = process.env.REACT_APP_REDIRECT_URL;
          }

          throw new Error("Произошла ошибка при удалении!")
        }
        return res;
      })
      .then(res => {
        return res.json();
      })
      .then(res => {
        if (res.success) {
          notification.success({
            message: "Конфигурационный файл успешно удален!"
          });
        }
        that.loadConfigs();
        
        that.setState({
          isLoading: false
        });
       ///return res; ///AK
      })
      .catch(err => {
        notification.error({
          message: err.message
        });
        
        that.setState({
          isLoading: false
        });
      });
  }

  componentWillMount() {
    var that = this;
    this.loadConfigs(function(){
      var pageGetParamsObject = {};
      window.location.search.substr(1)
      .split("&")
      .forEach((value, i, arr) => {
        var indexOfEqualSymbol = value.indexOf("=");
        pageGetParamsObject[value.substring(0, indexOfEqualSymbol)] = decodeURI(value.substr(indexOfEqualSymbol + 1));   
      });
      
      if(pageGetParamsObject.success == "true"){
        notification.success({
          message: pageGetParamsObject.message
        });
      }
      else if(pageGetParamsObject.success == "false"){  
        notification.error({
          message: pageGetParamsObject.message
        });
      }

      if(pageGetParamsObject.configName){
        that.setState({
          selectedConfig: pageGetParamsObject.configName
        });
      that.loadConfig(pageGetParamsObject.configName);///AK
      }
    });
  }

  getConfigs() {

    if(this.state.configNames.length === 0){
      return (
        <Empty image = {Empty.PRESENTED_IMAGE_SIMPLE} imagestyle={{ height: 20 }} 
               description = {<span>Нет контроллеров. Нажмите «Создать»</span>}
        />
      );
    }

    return this.state.configNames.map(n => (
      <Menu.Item key={n} onClick={e => this.onConfigSelection(e)}>
        <Popconfirm title="Подтвердите удаление" okText="Да" cancelText="Нет" onConfirm={e => this.removeConfig(n, e)} placement="bottomRight" >
          <Icon type="delete" key={n}
            onClick={e => { e.stopPropagation(); }}
            style={{ color: "red" }}
            title="Удалить"
            theme="twoTone"
            twoToneColor="red" />
        </Popconfirm>
        <span className="nav-text" class = {this.isConfigHaveUnsavedChanges(n) ? "have-unsaved-changes" : ""} title={n}>{n}</span>
      </Menu.Item>
    ));
  }

  isConfigHaveUnsavedChanges(configName){
    var unsavedControllers = 
      localStorage.getObj('unsavedControllers') || [];

    var unsavedControllersNames = unsavedControllers.map(function(item, index){
      return item.name;
    });

    return unsavedControllersNames != null && unsavedControllersNames.indexOf(configName) !== -1;
  }

  isAceEditorHaveValidContent(err) {
    var isSaveButtonDisabled = err.length !== 0 || this.state.configNames.length === 0;
    this.setState({ isSaveButtonDisabled: isSaveButtonDisabled });
  }

  onChange(newVal) {

    if(this.state.selectedConfig != ''){

      var unsavedControllers = 
      localStorage.getObj('unsavedControllers') || [];

      var unsavedControllerData = {
        name: this.state.selectedConfig,
        content: newVal
      };
      var that = this;
      var newUnsavedControllersData = unsavedControllers.filter(function(item, indexOf){
         return item.name !== that.state.selectedConfig;
      });

      newUnsavedControllersData.push(unsavedControllerData);
      localStorage.setObj('unsavedControllers', newUnsavedControllersData);
    }

    this.setState({ value: newVal, isHaveUnsavedChanges: true });
  }

  onConfigSelection(e) {
    var unsavedControllers = localStorage.getObj('unsavedControllers') || [];

    var unsavedControllersData = unsavedControllers.filter(function(item, index){
      if (!!e) ///AK
       return item.name === e.key;
      else return false;
    });

    if(unsavedControllersData.length !== 0){

      var unsavedControllerData = unsavedControllersData[0];

      this.setState({ 
        selectedConfig: e.key,
        value: unsavedControllerData.content 
      });
    }
    else{
      if (!!e) ///AK
      {
      this.loadConfig(e.key);
      this.setState({ selectedConfig: e.key })
      }
    }

    
  }

  saveConfig() {
    var aceEditorContent = this.state.value;
    let that = this;
    this.setState({
      isLoading: true
    });
    var saveHeaders =  that.getDefaultHeaders();
    saveHeaders.append('Content-Type', 'application/json');
    fetch(process.env.REACT_APP_API_ENDPOINT + "/configs/" + this.state.selectedConfig, {
      method: "post",
      body: JSON.stringify(
        {
          content: aceEditorContent
        }),
      headers: saveHeaders
    })
      .then(res => {
        if (!res.ok) {

          if(res.status === 401){
            window.location = process.env.REACT_APP_REDIRECT_URL;
          }

          throw new Error("Нет соединения с сервером! Попробуйте позже.");
        }
        return res;
      })
      .then(res => {
        return res.json();
      })
      .then(res => {
        if (res.success === true) {
          notification.success({
            message: "Конфигурационный файл успешно сохранен!"
          });

          that.setState({ isSaveButtonDisabled: true });
        }
   
        var unsavedControllers = localStorage.getObj('unsavedControllers') || [];

        var newControllersData = unsavedControllers.filter(function(item, index){
          return item.name !== that.state.selectedConfig;
        });

        localStorage.setObj('unsavedControllers', newControllersData);

        that.setState({
          isLoading: false
        });
      })
      .catch(err => {
        notification.error({
          message: err.message
        });
        
        that.setState({
          isLoading: false
        });
      });
  }

  loadConfig(configName) {

    let that = this;
    this.setState({
      isLoading: true
    });
    fetch(process.env.REACT_APP_API_ENDPOINT + "/configs/" + configName, {
      method: "get",
      headers: that.getDefaultHeaders()
    })
      .then(res => {
        if (!res.ok) {

          if(res.status === 401){
            window.location = process.env.REACT_APP_REDIRECT_URL;
          }

          throw new Error("Нет соединения с сервером! Попробуйте позже.");
        }
        return res;
      })
      .then(res => {
        return res.text();
      })
      .then(data => {
        that.setState({ 
          value: data,
          isLoading: false 
        });
      })
      .catch(err => {
        notification.error({
          message: err.message
        });
        
        that.setState({
          isLoading: false
        });
      });
  }

  render() {

    return (
      <Spin spinning = {this.state.isLoading} size = "large">
      <Layout>
        
        <Layout>
          <Header style={{ background: '#fff', padding: 0, paddingBottom: "150px" }}>
            <Layout style={{ background: "#001529" }}>
              <Menu theme="light" mode="vertical-left" selectedKeys={[this.state.selectedConfig]} style={{ height: "140px", overflowY: "auto" }}>
                {this.getConfigs()}
              </Menu>
            </Layout>
          </Header>
          <Content style={{ margin: '24px 16px 0', overflow: 'initial', height: "100%" }}>
            <div className="App">
              <div style={{ marginBottom: "10px" }}>
                <Button type="primary" icon="file-add"  onClick={_ => { this.setState({ isCreateNewConfigFileVisible: true })}}>Создать</Button>
                <Button type="default" icon="save" disabled={this.state.isSaveButtonDisabled} onClick={this.saveConfig} style = {{ marginLeft: "10px"}}>Сохранить</Button>
              </div>

              <AceEditor
                placeholder="Начните ввод.."
                mode="json"
                theme="github"
                name="blah2"
                width="100%"
                height = {(window.innerHeight - 230) + "px"}
                onValidate={this.isAceEditorHaveValidContent}
                onChange={this.onChange}
                value={this.state.value}
                fontSize={18}
                editorProps={{ $blockScrolling: true }}
                setOptions={{
                  enableBasicAutocompletion: true,
                  enableLiveAutocompletion: true,
                  enableSnippets: false,
                  showLineNumbers: true,
                  tabSize: 2,
                }}
              />
            </div>
          </Content>
        </Layout>

        <Modal
          title="Создание нового конфигурационного файла"
          visible={this.state.isCreateNewConfigFileVisible}
          onCancel={_ => { this.setState({ isCreateNewConfigFileVisible: false, newConfigFileName: "" }) }}
          footer={[]}>
          <Form layout="inline" onSubmit={this.onCreateConfig}>
            <Form.Item
              required={true}
              label="MAC Адрес контроллера"
              validateStatus={this.state.isValidNewConfigName ? "success" : "error"}
              help={this.state.isValidNewConfigName ? "Все верно! Можете сохранять." : "Введите корректный MAC Адрес контроллера! Например, 1fac1245aacc, 1f:ac:12:45:aa:cc или 1f-ac-12-45-aa-cc."}>
              <Input allowClear
                ref={(input) => input && input.focus()}
                onChange={this.onNewConfigFileNameChange}
                onPressEnter={this.onCreateConfig}
                style={{ width: 300 }}
                addonBefore={<Icon type="setting" />}
                value={this.state.newConfigFileName} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType={"submit"} icon="file-add" disabled={!this.state.isValidNewConfigName}>ОК</Button>
            </Form.Item>
          </Form>
        </Modal>
      </Layout>
      </Spin>
    );
  }
}

export default App;
